import React, { useEffect, useState } from 'react'
import MeetSlider from '../Components/slider/MeetSlider';
// import TestSlider from '../Components/slider/TestSlider';
import GallerySlider from '../Components/slider/GallerySlider';
import { ArrowRight } from 'lucide-react';
import Aos from 'aos';
import GlobalSlider from '../Components/slider/GlobalSlider';
// import OurSlider from '../Components/slider/OurSlider';
import LogoSlider from '../Components/slider/LogoSlider';
import RegisterModal from '../Components/modal/RegisterModal';
import LogoSlider2 from '../Components/slider/LogoSlider2';
import EventSlider from '../Components/slider/EventSlider';
// import HeroSlider from '../Components/slider/HeroSlider';


const pricing = [
    {
        text: " Global alumni directory access "
    },
    {
        text: " Priority invites & free/discounted event access "
    },
    {
        text: "  Mentorship with established alumni"
    },
    {
        text: "  Networking circles & leadership forums"
    },
    {
        text: "  Recognition as “Alumni Achievers” features "
    },
    {
        text: " Partner brand discounts (travel, lifestyle, wellness, etc.)"
    },
    {
        text: " Access to VANs retreats & curated trips"
    },
    {
        text: " Early access to jobs, gigs & business referrals"
    },
]
const acc = [
    {
        label: "Professional Networking & Internship Pathways",
        text: "That roommate who knew all your secrets? She's now a CEO in Singapore. Ready to reconnect? Connect with inspiring seniors who once motivated you during assembly, now ready to guide your career with genuine warmth. Because the best advice comes from sisters who've walked your path."
    },
    {
        label: "Mentorship & Career Growth",
        text: "Skip the cold LinkedIn messages. Get career advice from sisters who actually want to see you win. Access exclusive job postings and premium internships shared by fellow alumnae. When a VDJS recommends you, doors don't just open—they swing wide with enthusiasm."
    },
    // {
    //     label: "Alumni Reunions & Celebratory Events",
    //     text: "Less awkward small talk, more 'OMG remember when we...' and dancing till 2am like old times. From cozy Hisar campus visits to glamorous city reunions worldwide, our events bring back that authentic VDJS magic. The Jindalite spirit burns just as bright, wherever we gather."
    // },
    {
        label: "Giving Back to Our School",
        text: "Be the inspiring senior you once looked up to. Help today's VDJS girls write their own stories. Mentor current students, fund life-changing scholarships, or support campus projects. It's your turn to be the reason someone's eyes light up during assembly, just like yours once did."
    },
    {
        label: "Global Network of Sisterhood",
        text: "Moving to a new city? Starting fresh somewhere? Your VANs family is already there, waiting with open arms. From trusted accommodation during business trips to insider city tips, your global sisters have your back. Once you've shared midnight snacks and dreams, you're family for life."
    },
]
const acc2 = [
    {
        label: "Mentor Our Current Students",
        text: "Share your journey with today's VDJS girls who remind you of your younger self. Guide them through career choices, life decisions, or simply be the encouraging voice they need. One conversation could change everything—just like it did for you."
    },
    {
        label: "Career & Internship Opportunities",
        text: "Help build VANs communities in your city and bring sisters together. Host meetups, organize professional events, or simply be the friendly face welcoming newcomers. Your city could be the next thriving VANs hub."
    },
    {
        label: "Share Golden Opportunities",
        text: "Pass along job openings, internships, and collaborations within our network. When you come across that perfect role, think VANs first. Help a sister land her dream job—because VDJS girls lifting VDJS girls is what we're all about."
    },
    {
        label: "Fund Tomorrow's Dreams",
        text: "Contribute to scholarships that give deserving students the same opportunities you had. Whether it's ₹1,000 or ₹1,00,000, every contribution writes someone's success story. Help create the next generation of inspiring VDJS."
    },
    {
        label: "Enhance Our Beloved Campus",
        text: "Support infrastructure projects that will create memories for future generations. From library expansions to sports facilities, help make VDJS Hisar even more magical for the girls who'll walk those red-brick paths after us."
    },
    {
        label: "Spread the VANs Love",
        text: "Help us find more lost sisters and bring them back to the family. Share VANs with classmates, batch-mates, or that friend who's been 'too busy' to join. Sometimes all someone needs is a gentle nudge from a frien"
    },
]
const faqs = [
    {
        label: "What the VDJS Alumni Association does with the membership fee?",
        text: "Your Lifetime Membership Fee of ₹3500 is a shared contribution towards strengthening our alumni family. It ensures that VANs runs with transparency, supports meaningful initiatives, and builds a sustainable future for our community. Becoming a bona fide member is not just about formal recognition, it is about belonging, giving back, and carrying forward the proud legacy of VDJS together."
    },
    {
        label: "Is my membership transferrable?",
        text: "No, once a membership is bought it’s a lifetime investment which every alum can do for themselves."
    },
    {
        label: "How do I verify my VDJS alumni status?",
        text: "We verify alumni status through batch year, student ID, or connection with existing verified members. Our team manually reviews each application to ensure authenticity and maintain the exclusive nature of our network."
    },
    {
        label: "What makes VANs different from LinkedIn or other networks?",
        text: "VANs is built on authentic shared experiences and sisterhood bonds from VDJS. Unlike generic platforms, we offer curated connections, exclusive events, verified alumni, and meaningful relationships based on trust and common heritage."
    },
    {
        label: "Is my personal information secure?",
        text: "Absolutely. We use enterprise-grade security, SSL encryption, and comply with international privacy laws. Your data is never shared with third parties, and you control your visibility settings within the network."
    },
]

// const faq = [
//     {
//         label: "How do I verify my VDJS alumni status?",
//         text: "We verify alumni status through batch year, student ID, or connection with existing verified members. Our team manually reviews each application to ensure authenticity and maintain the exclusive nature of our network."
//     },
//     {
//         label: "What makes VANS different from LinkedIn or other networks?",
//         text: "VANS is built on authentic shared experiences and sisterhood bonds from VDJS. Unlike generic platforms, we offer curated connections, exclusive events, verified alumni, and meaningful relationships based on trust and common heritage."
//     },
//     {
//         label: "Can I upgrade or downgrade my membership?",
//         text: "Yes, you can change your membership tier at any time. Upgrades take effect immediately, while downgrades apply at your next billing cycle. The founding member discount is locked in for life once you join."
//     },
//     {
//         label: "How active is the network globally?",
//         text: "We have active alumni in 127 cities across 6 continents. Major hubs include Mumbai, Delhi, New York, London, Singapore, Dubai, Toronto, and Melbourne. Regional chapters organize monthly meetups and annual reunions."
//     },
//     {
//         label: "Is my personal information secure?",
//         text: "Absolutely. We use enterprise-grade security, SSL encryption, and comply with international privacy laws. Your data is never shared with third parties, and you control your visibility settings within the network."
//     },
// ]

function Home() {
    const [openModal, setOpenModal] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeIndex1, setActiveIndex1] = useState(null);
    const [activeIndex2, setActiveIndex2] = useState(null);
    const targetDate = new Date();
    targetDate.setMonth(targetDate.getMonth() + 3);
    const [timeLeft, setTimeLeft] = useState(getTimeRemaining());

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    const toggleAccordion1 = (index) => {
        setActiveIndex1(activeIndex1 === index ? null : index);
    };
    const toggleAccordion2 = (index) => {
        setActiveIndex2(activeIndex2 === index ? null : index);
    };

    useEffect(() => {
        Aos.init({
            duration: 1000,
            once: true,
        });
    }, []);

    function getTimeRemaining() {
        const now = new Date();
        const difference = targetDate - now;

        let time = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };

        if (difference > 0) {
            time = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / (1000 * 60)) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return time;
    }

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(getTimeRemaining());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <section className='lg:pt-[38px] pt-[30px] relative mt-[61px] lg:mt-[73px] pb-[50px] lg:pb-[96px] hero-bg overflow-hidden'>
                <div className="slide"></div>
                <div className="slide"></div>
                <div className="slide"></div>
                <div className="absolute inset-0 bg-[#08717D]/50"></div>
                <div className="flex max-w-[1440px] w-full mx-auto text-left flex-col items-start h-full justify-center lg:gap-[65px] gap-[16px] lg:px-[100px] px-[20px]">
                    <div data-aos="fade-right" className=' text-center'>
                        {/* <div className="flex gap-[12px] items-center justify-center lg:justify-start">
                            <img src="/assets/home/book.png" className='h-[20px] lg:h-[23px]' alt="" />
                            <p className="font-[600] font-manrope text-[16px] sm:text-[18px] lg:text-[20px] leading-[28px] lg:leading-[32px] text-primary">
                                Welcome to VANS
                            </p>
                        </div> */}

                        <h1 className=' text-[#ffc507] text-left font-[700] font-playfair text-[35px] lg:text-[50px] leading-[46px] lg:leading-[60px] lg:mt-[20px]'>
                            <span className='text-[#FFFFFF]'>
                                Welcome to the official <br />
                            </span>
                            VDJS Alumni Network
                        </h1>

                        <p className="pt-[20px] text-left sm:pt-[30px] lg:pt-[38px] font-manrope font-[400] text-[14px] lg:text-[24px] leading-[24px] lg:leading-[30px] text-[#FFFFFF] pb-[30px] lg:pb-[60px]">
                            Let the nostalgia hit you like kadhi-chawal on a Tuesday!
                        </p>
                        <div className="flex justify-start">
                            <div className="relative inline-block text-left group">
                                <a href="https://forms.gle/LYgBKQ6RYsr7riRHA" target="_blank" rel="noopener noreferrer">
                                    <button
                                        className="flex items-center justify-center lg:justify-start gap-[20px] sm:gap-[30px] bg-primary rounded-[4px] py-[12px] sm:py-[14px] px-[18px] sm:px-[20px] font-[500] font-manrope text-[14px] sm:text-[16px] leading-[24px] sm:leading-[26px] text-[#FFFFFF] transition-all duration-300 hover:text-primary border border-primary hover:bg-[#FFFFFF]">
                                        Register Now
                                        <ArrowRight
                                            size={18}
                                            className="transition-transform duration-300 group-hover:translate-x-1"
                                        />
                                    </button>
                                </a>
                                {/* <div className="absolute left-0 mt-2 w-64 origin-top-left bg-white border border-gray-200 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transform scale-95 group-hover:scale-100 transition-all duration-200 ease-out z-50">
                                    <ul className="py-2 text-sm text-gray-700 h-[180px] overflow-y-auto">
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Name</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Batch</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Year</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Country</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Email</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Phone no</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Location</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Professional Background</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Professional Industry</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Industry expertise</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Undergraduate degree</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Postgraduate degrees</li>
                                        <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Socials</li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    {/* <div data-aos="zoom-in-up" className='w-full mx-auto relative flex justify-end max-w-[1050px] lg:p-[10px] pr-0 p-[20px] pt-0'>
                        <img src="/assets/home/p1.png" alt="" />
                        <div className="flex gap-[20px] sm:gap-[30px] lg:gap-[42px] items-start">
                            <div>
                                <img src="/assets/home/img3.png" className='w-[150px] sm:w-[220px] lg:w-[324px] mt-[20px] lg:mt-[38px]' alt="" />
                                <img src="/assets/home/img2.png" className='w-[120px] sm:w-[160px] lg:w-[208px] mt-[30px] sm:mt-[40px] lg:mt-[52px] ml-[10px] lg:ml-[20px]' alt="" />
                            </div>
                            <img src="/assets/home/img1.png" className='w-[140px] sm:w-[180px] lg:w-[242px]' alt="" />
                        </div>
                        <div className='absolute top-[180px] sm:top-[220px] lg:top-[280px] right-[-20px] sm:right-[-40px] lg:right-[-64px] z-10 hidden sm:block'>
                        </div>
                    </div> */}
                </div>
            </section>
            {/* <div className="overflow-hidden pt-[80px]">
                <HeroSlider />
            </div> */}
            <section id="about" className='lg:py-[80px] overflow-hidden py-[40px] px-[20px] bg-[#FFFDF7]'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-[48px] gap-[24px]">
                        <div>
                            <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">About
                                <span className='text-[#ffc507]'> US</span></h6>
                            <p className="text-[#4a4a4a] text-justify text-[18px] font-[400] leading-[28px] mb-[24px] font-manrope">The VDJS Alumni Network (VANs) is a vibrant and intergenerational community of empowered women who share a common beginning Vidya Devi Jindal School. Built on the legacy of girls' residential education, VANs serves as a dynamic platform for connection, inspiration, and lifelong engagement.
                                With over 3000+ alumni across the globe, the Network brings together Jindalites from diverse backgrounds professionals, entrepreneurs, changemakers, artists, educators, and homemakers united by their roots and driven to uplift one another.
                            </p>
                            <p className="text-[#4a4a4a] text-[18px] text-justify font-[400] leading-[28px] mb-[24px] font-manrope">Whether you're just starting out or decades into your journey, there’s always a place and a purpose for you within VANs.</p>
                            <p className="text-[#4a4a4a] text-[18px] text-justify font-[400] leading-[28px] mb-[24px] font-manrope">Once a Jindalite, always a Jindalite!</p>
                            <div className="grid lg:grid-cols-3">
                                <div className="flex flex-col items-center justify-center">
                                    <h6 className="text-[30px] font-[700] font-manrope text-[#08717D] text-center">40+</h6>
                                    <p className="text-[14px] leading-[20px] font-manrope capitalize text-[#4a4a4a]">years of legacy</p>
                                </div>
                                <div className="flex flex-col items-center justify-center">
                                    <h6 className="text-[30px] font-[700] font-manrope text-[#08717D] text-center">5k+</h6>
                                    <p className="text-[14px] leading-[20px] font-manrope text-[#4a4a4a] capitalize">strong Jindalite network</p>
                                </div>
                                <div className="flex flex-col items-center justify-center">
                                    <h6 className="text-[30px] font-[700] font-manrope text-[#08717D] text-center">3000+</h6>
                                    <p className="text-[14px] leading-[20px] font-manrope text-[#4a4a4a]">Alums Connected </p>
                                </div>
                            </div>
                        </div>
                        <div className=''>
                            {/* <div>
                                <img src="/assets/hero/img4.jpeg" className='h-[192px] rounded-[8px] object-cover w-full' alt="" />
                            </div> */}
                            <img src="/assets/event/img10.png" className='mt-[32px] max-w-[100%] w-full object-cover h-[400px] rounded-[8px]' alt="" />
                        </div>
                    </div>
                </div>
            </section>
            <section className='pt-[50px] md:pt-[100px] pb-[100px] md:pb-[100px] overflow-hidden relative'>
                <div className='px-[20px] md:pl-[60px] pb-[40px]'>
                    <h6 className="font-[600] font-playfair text-[40px] mb-[14px] text-[#08717D]">Meet our
                        <span className='text-[#ffc507]'> VANs Core
                        </span> committee </h6>
                    <p className="text-[#4a4a4a] text-[18px] font-[400] leading-[28px] font-manrope lg:text-left text-center">Faces of Inspiration</p>
                </div>
                <div className='pl-[20px] md:pl-[60px] pr-[20px]'>
                    <MeetSlider />
                </div>
            </section>
            <section id="events" className='bg-[#FFFFFF] px-[20px] overflow-hidden sm:px-[30px] lg:px-[40px]'>
                <div className=' max-w-[1280px] w-full mx-auto lg:pb-[110px] pb-[50px] lg:px-[80px] px-[20px]'>
                    <div className='px-[20px] flex flex-col items-center md:pl-[60px] pb-[40px]'>
                        <h6 className="font-[600] font-playfair text-[40px] mb-[14px] text-[#08717D]">Past and Upcoming
                            <span className='text-[#ffc507]'> Events
                            </span> </h6>
                        <p className="text-[#4a4a4a] max-w-[540px] text-center w-full mx-auto text-[18px] font-[400] leading-[28px] font-manrope">Join us at VANs for our events designed to enrich your academic and personal development experience</p>
                    </div>
                    <div className="grid lg:grid-cols-2 grid-cols-1 items-start gap-[30px]">

                        <div data-aos="fade-right" className="flex flex-col w-full">
                            <div className="pb-[14px] w-full">
                                <h6 className="font-[700] font-manrope text-[20px] sm:text-[24px] lg:text-[30px] leading-[30px] sm:leading-[36px] lg:leading-[48px] text-[#1F2544] truncate whitespace-nowrap block w-full">
                                     VDJS Alumni Network launch at our AlmaMater
                                </h6>
                            </div>
                            <div className="w-full aspect-video overflow-hidden rounded-[8px]">
                                <img src="/assets/event/img1.jpeg" className="w-full h-full object-cover" alt="" />
                            </div>
                        </div>

                        <div data-aos="fade-left" className="flex flex-col w-full">
                            <div className="pb-[14px] w-full">
                                <h6 className="font-[700] font-manrope text-[20px] sm:text-[24px] lg:text-[30px] leading-[30px] sm:leading-[36px] lg:leading-[48px] text-[#1F2544] truncate whitespace-nowrap block w-full">
                                    Delhi NCR Regional Chapter launch: First of many 
                                </h6>
                            </div>
                            <div className="w-full aspect-video overflow-hidden rounded-[8px]">
                                <img src="/assets/event/img9.jpeg" className="w-full h-full object-cover" alt="" />
                            </div>
                        </div>

                        <div data-aos="fade-right" className="flex flex-col w-full">
                            <div className="pb-[14px] w-full">
                                <h6 className="font-[700] font-manrope text-[20px] sm:text-[24px] lg:text-[30px] leading-[30px] sm:leading-[36px] lg:leading-[48px] text-[#1F2544] truncate whitespace-nowrap block w-full">
                                     ⁠Kadhi Tales: Stories, memories, conversations online
                                </h6>
                            </div>
                            <div className="w-full aspect-video overflow-hidden rounded-[8px]">
                                <img src="/assets/event/img12.jpeg" className="w-full h-full object-cover" alt="" />
                            </div>
                        </div>

                        <div data-aos="fade-left" className="flex flex-col w-full">
                            <div className="pb-[14px] w-full">
                                <h6 className="font-[700] font-manrope text-[20px] sm:text-[24px] lg:text-[30px] leading-[30px] sm:leading-[36px] lg:leading-[48px] text-[#1F2544] truncate whitespace-nowrap block w-full">
                                    Taking VANs Global: Kathmandu reunion
                                </h6>
                            </div>
                            <div className="w-full aspect-video overflow-hidden rounded-[8px]">
                                <img src="/assets/event/img3.jpeg" className="w-full h-full object-cover" alt="" />
                            </div>
                        </div>
                        <div data-aos="fade-right" className="flex flex-col w-full">
                            <div className="pb-[14px] w-full">
                                <h6 className="font-[700] font-manrope text-[20px] sm:text-[24px] lg:text-[30px] leading-[30px] sm:leading-[36px] lg:leading-[48px] text-[#1F2544] truncate whitespace-nowrap block w-full">
                                     Principal Series: Conversations with mentors who shaped us
                                </h6>
                            </div>
                            <div className="w-full aspect-video overflow-hidden rounded-[8px]">
                                <img src="/assets/event/img11.jpeg" className="w-full h-full object-cover" alt="" />
                            </div>
                        </div>

                        <div data-aos="fade-left" className="flex flex-col w-full">
                            <div className="pb-[14px] w-full">
                                <h6 className="font-[700] font-manrope text-[20px] sm:text-[24px] lg:text-[30px] leading-[30px] sm:leading-[36px] lg:leading-[48px] text-[#1F2544] truncate whitespace-nowrap block w-full">
                                    Com-Acumen 2026: Alumni judging and mentoring student talent
                                </h6>
                            </div>
                            <div className="w-full aspect-video overflow-hidden rounded-[8px]">
                                <img src="/assets/event/img13.jpeg" className="w-full h-full object-cover" alt="" />
                            </div>
                        </div>

                    </div>
                    {/* <div className="">
                        <EventSlider />
                        <p className="text-[#4a4a4a] text-center text-[18px] font-[400] leading-[28px] mb-[24px] font-manrope">Virtual Tales – Principal Series - digital storytelling and dialogue platform that brings VDJS alumni together with former principals to revisit defining moments, leadership journeys, and the values that shaped generations of students — fostering reflection, connection, and institutional pride across eras.</p>
                    </div> */}
                </div>
            </section>
            <section id="membership" className='lg:py-[80px] bg-[#FFFDF7] py-[50px] lg:px-[60px] px-[20px]'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className='flex flex-col items-center pb-[64px]'>
                        <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">Exclusive Membership
                            <span className='text-[#ffc507]'> Benefits</span></h6>
                        <p className="text-[#4a4a4a] text-center text-[18px] max-w-[568px] w-full mx-auto font-[400] leading-[28px] mb-[24px] font-manrope">Transform your VDJS connection into career opportunities, lifelong friendships, and global impact</p>
                    </div>
                    <div className="grid lg:grid-cols-2 items-center grid-cols-1 lg:gap-[48px] gap-[14px]">
                        <div className="grid lg:gap-[20px] gap-[14px]">
                            {acc.map((item, index) => (
                                <div key={index} className="border-b border-[#E9E9EC] self-start">
                                    <div
                                        className="flex justify-between items-center transition-all duration-300 
        hover:bg-primary bg-[#E9E9EC] py-[12px] sm:py-[15px] px-[15px] 
        sm:px-[20px] cursor-pointer group"
                                        onClick={() => toggleAccordion(index)}
                                    >
                                        <h6
                                            className="font-[600] font-manrope text-[14px] sm:text-[16px] 
          leading-[22px] sm:leading-[26px] text-[#222222] 
          transition-colors duration-300 group-hover:text-white"
                                        >
                                            {item.label}
                                        </h6>
                                        <button className="transition-transform duration-300 group-hover:scale-110">
                                            {activeIndex === index ? (
                                                <img
                                                    src="/assets/home/minus.svg"
                                                    alt="-"
                                                    className="w-5 h-5 transition-colors duration-300 
              group-hover:brightness-0 group-hover:invert"
                                                />
                                            ) : (
                                                <img
                                                    src="/assets/home/plush.svg"
                                                    alt="+"
                                                    className="w-5 h-5 transition-colors duration-300 
              group-hover:brightness-0 group-hover:invert"
                                                />
                                            )}
                                        </button>
                                    </div>

                                    <div
                                        className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${activeIndex === index ? "max-h-[500px]" : "max-h-0"
                                            }`}
                                    >
                                        <div className="px-[15px] sm:px-[20px] py-[12px] sm:py-[15px] bg-[#FFFDF7] text-[#444] font-manrope text-[13px] sm:text-[14px] leading-[20px] sm:leading-[22px]">
                                            {item.text}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='relative'>
                            {/* <div className="absolute inset-0 bg-[#08717D]/50 rounded-[8px]"></div> */}
                            <img src="/assets/hero/img7.jpeg" className='rounded-[8px] lg:h-[384px] object-cover' alt="" />
                        </div>
                    </div>
                </div>
            </section>
            <section className='lg:pb-[80px] overflow-hidden pb-[50px] lg:px-[60px] px-[20px] bg-[#FFFDF7]'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-[100px] gap-[30px]">
                        <div>
                            <div className='flex flex-col items-start pb-[24px]'>
                                <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">Choose Your
                                    <span className='text-[#ffc507]'> Sisterhood
                                    </span>
                                </h6>
                                <p className="text-[#4a4a4a] max-w-[448px] text-center text-[18px] w-full font-[400] leading-[28px] font-manrope">Limited time offer</p>
                            </div>
                            <div className="max-w-[448px] w-full bg-[#08717db4] rounded-xl border border-[#08717d] p-[1rem]">
                                <p className='text-center text-[#FFFFFF] pb-[18px] font-[400] leading-[28px] font-manrope text-[18px] capitalize    '>first 50 members will get 30% off</p>
                                <div className="grid grid-cols-4 gap-[16px] lg:px-[30px]">
                                    <div className='flex flex-col gap-[0px] items-center'>
                                        <h6 className="text-[#FFFFFF] font-[600] leading-[38px] font-manrope text-[28px]">{timeLeft?.days}</h6>
                                        <p className='text-center text-[#FFFFFF] pb-[18px] font-[400] leading-[28px] font-manrope text-[18px]'>Days</p>
                                    </div>
                                    <div className='flex flex-col gap-[0px] items-center'>
                                        <h6 className="text-[#FFFFFF] font-[600] leading-[38px] font-manrope text-[28px]">{timeLeft?.hours}</h6>
                                        <p className='text-center text-[#FFFFFF] pb-[18px] font-[400] leading-[28px] font-manrope text-[18px]'>Hours</p>
                                    </div>
                                    <div className='flex flex-col gap-[0px] items-center'>
                                        <h6 className="text-[#FFFFFF] font-[600] leading-[38px] font-manrope text-[28px]">{timeLeft?.minutes}</h6>
                                        <p className='text-center text-[#FFFFFF] pb-[18px] font-[400] leading-[28px] font-manrope text-[18px]'>Minutes</p>
                                    </div>
                                    <div className='flex flex-col gap-[0px] items-center'>
                                        <h6 className="text-[#FFFFFF] font-[600] leading-[38px] font-manrope text-[28px]">{timeLeft?.seconds}</h6>
                                        <p className='text-center text-[#FFFFFF] pb-[18px] font-[400] leading-[28px] font-manrope text-[18px]'>Seconds</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='max-w-[484px] mx-auto bg-[#FFFFFF] rounded-[16px] p-[32px] w-full' style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" }}>
                            <h6 className="font-[600] font-playfair text-center text-[24px] text-[#08717D] pb-[20px]">VAN's Lifetime Membership</h6>
                            {/* <p className='text-center text-[#4a4a4a] py-[18px] font-[400] leading-[28px] font-manrope text-[18px]'>VANs membership</p> */}
                            <h6 className="text-center font-manrope font-[600] leading-[38px] text-[28px]">
                                <span className="text-[#08717D] line-through mr-2"> ₹5000 /-</span>
                                <span className="text-[#08717D]">&nbsp;₹3500 /- </span>
                                <span className="text-[#08717D]">for Lifetime</span>
                            </h6>

                            <div className="flex flex-col items-start gap-[10px] pt-[20px]">
                                {pricing?.map((e, i) => {
                                    return (
                                        <div key={i} className="flex items-center gap-[10px]">
                                            <svg class="w-5 h-5 text-success mr-3" fill="#2e7d32" viewBox="0 0 20 20" data-component-id="8-0-1-0-1-0-0" data-component-path="/pages/landing_page.html" data-component-name="svg" data-component-file="landing_page.html" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-5%20h-5%20text-success%20mr-3%22%7D">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                            </svg>
                                            <p className='text-left  text-[#4a4a4a] font-[400] leading-[20px] font-manrope text-[16px]'>{e?.text}</p>
                                        </div>

                                    )
                                })}
                                <div className="flex justify-center pt-[20px] w-full">
                                    <button
                                        className="text-white bg-[#08717D] text-[16px] font-[600] font-manrope border border-[#08717D] rounded-[6px] px-[20px] py-[8px] hover:bg-white hover:text-primary transition-all duration-300">
                                        Coming Soon
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="stories" className='lg:py-[80px] py-[50px] lg:px-[120px] px-[20px] bg-[#FFFFFF]'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className='flex flex-col items-center pb-[64px]'>
                        <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">From VDJ's to
                            <span className='text-[#ffc507]'> Global Success
                            </span>
                        </h6>
                        <p className="text-[#4a4a4a] text-center text-[18px] max-w-[468px] w-full mx-auto font-[400] leading-[28px] mb-[24px] font-manrope">Meet the extraordinary women who transformed their VDJS foundation into worldwide impact</p>
                    </div>
                    <div className="overflow-hidden">
                        <GlobalSlider />
                    </div>
                </div>
            </section>
            <section id="contribute" className='lg:pb-[80px] pb-[50px] lg:px-[60px] px-[20px]'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className='flex flex-col items-center pb-[64px]'>
                        <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">Giving Back to Our
                            <span className='text-[#ffc507]'> VDJS Legacy
                            </span></h6>
                        <p className="text-[#4a4a4a] text-center text-[18px] max-w-[568px] w-full mx-auto font-[400] leading-[28px] mb-[24px] font-manrope">Empower the next generation of VDJS women through mentorship, scholarships, and career guidance</p>
                    </div>
                    <div className="grid lg:grid-cols-2 grid-cols-1 items-start lg:gap-[20px] gap-[14px]">
                        {acc2.map((item, index) => (
                            <div key={index} className="border-b border-[#E9E9EC] self-start">
                                <div
                                    className="flex justify-between items-center transition-all duration-300 
        hover:bg-primary bg-[#E9E9EC] py-[12px] sm:py-[15px] px-[15px] 
        sm:px-[20px] cursor-pointer group"
                                    onClick={() => toggleAccordion1(index)}
                                >
                                    <h6
                                        className="font-[600] font-manrope text-[14px] sm:text-[16px] 
          leading-[22px] sm:leading-[26px] text-[#222222] 
          transition-colors duration-300 group-hover:text-white"
                                    >
                                        {item.label}
                                    </h6>
                                    <button className="transition-transform duration-300 group-hover:scale-110">
                                        {activeIndex1 === index ? (
                                            <img
                                                src="/assets/home/minus.svg"
                                                alt="-"
                                                className="w-5 h-5 transition-colors duration-300 
              group-hover:brightness-0 group-hover:invert"
                                            />
                                        ) : (
                                            <img
                                                src="/assets/home/plush.svg"
                                                alt="+"
                                                className="w-5 h-5 transition-colors duration-300 
              group-hover:brightness-0 group-hover:invert"
                                            />
                                        )}
                                    </button>
                                </div>

                                <div
                                    className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${activeIndex1 === index ? "max-h-[500px]" : "max-h-0"
                                        }`}
                                >
                                    <div className="px-[15px] sm:px-[20px] py-[12px] sm:py-[15px] bg-[#FFFDF7] text-[#444] font-manrope text-[13px] sm:text-[14px] leading-[20px] sm:leading-[22px]">
                                        {item.text}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* <section className='lg:py-[80px] py-[50px] lg:px-[120px] px-[20px] bg-cream'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className='flex flex-col items-center pb-[64px]'>
                        <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">What Our
                            <span className='text-[#ffc507]'> Sisterhood
                            </span> Says</h6>
                        <p className="text-[#4a4a4a] text-center text-[18px] max-w-[768px] w-full mx-auto font-[400] leading-[28px] mb-[24px] font-manrope">Real stories from alumni who transformed their careers through authentic VDJS connections</p>
                    </div>
                    <div className="overflow-hidden">
                        <OurSlider />
                    </div>
                </div>
            </section> */}

            <section className='lg:py-[80px] py-[50px] overflow-hidden lg:px-[120px] px-[20px]'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className='flex flex-col items-center pb-[64px]'>
                        <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">Trusted by
                            <span className='text-[#ffc507]'> Global Leaders
                            </span></h6>
                        <p className="text-[#4a4a4a] text-center lowercase text-[18px] max-w-[768px] w-full mx-auto font-[400] leading-[28px] mb-[24px] font-manrope">Our alumni work at the world's most prestigious organizations</p>
                    </div>
                    <div className='pb-[60px] overflow-hidden'>
                        <LogoSlider />
                        {/* <div className='pt-[8px]'>
                            <LogoSlider2 />
                        </div> */}
                    </div>
                    {/* <div className="grid lg:grid-cols-4 grid-cols-2 gap-6">
                        <div className="flex flex-col items-center justify-center">
                            <h6 className="text-[30px] font-[700] font-manrope text-[#08717D] text-center">
                                <CountUp end={40} duration={2.5} />+
                            </h6>
                            <p className="text-[14px] leading-[20px] font-manrope text-[#4a4a4a]">
                                Years of Excellence
                            </p>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <h6 className="text-[30px] font-[700] font-manrope text-[#08717D] text-center">
                                <CountUp end={6} duration={2.5} />+
                            </h6>
                            <p className="text-[14px] leading-[20px] font-manrope text-[#4a4a4a]">
                                Continents
                            </p>
                        </div>

                        <div className="flex flex-col items-center justify-center">
                            <h6 className="text-[30px] font-[700] font-manrope text-[#08717D] text-center">
                                <CountUp end={127} duration={3} />
                            </h6>
                            <p className="text-[14px] leading-[20px] font-manrope text-[#4a4a4a]">
                                Cities Worldwide
                            </p>
                        </div>

                        <div className="flex flex-col items-center justify-center">
                            <h6 className="text-[30px] font-[700] font-manrope text-[#08717D] text-center">
                                <CountUp end={2700} duration={3.5} />+
                            </h6>
                            <p className="text-[14px] leading-[20px] font-manrope text-[#4a4a4a]">
                                Connected Alumni
                            </p>
                        </div>
                    </div> */}
                    <div className="flex justify-center items-center gap-[32px]">
                        <div className="flex items-center gap-[8px]">
                            <svg class="w-6 h-6 text-success" fill="#488d4c" viewBox="0 0 20 20" data-component-id="7-0-3-0-0" data-component-path="/pages/landing_page.html" data-component-name="svg" data-component-file="landing_page.html" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-6%20h-6%20text-success%22%7D">
                                <path fill-rule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                            </svg>
                            <p className="font-[400] font-manrope text-[14px] leading-[20px]">SSL Secured</p>
                        </div>
                        <div className="flex items-center gap-[8px]">
                            <svg class="w-6 h-6 text-success" fill="#488d4c" viewBox="0 0 20 20" data-component-id="7-0-3-1-0" data-component-path="/pages/landing_page.html" data-component-name="svg" data-component-file="landing_page.html" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-6%20h-6%20text-success%22%7D">
                                <path fill-rule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clip-rule="evenodd"></path>
                            </svg>
                            <p className="font-[400] font-manrope text-[14px] leading-[20px]">Privacy Protected</p>
                        </div>
                        <div className="flex items-center gap-[8px]">
                            <svg class="w-6 h-6 text-success" fill="#488d4c" viewBox="0 0 20 20" data-component-id="7-0-3-2-0" data-component-path="/pages/landing_page.html" data-component-name="svg" data-component-file="landing_page.html" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-6%20h-6%20text-success%22%7D">
                                <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                            </svg>
                            <p className="font-[400] font-manrope text-[14px] leading-[20px]">Verified Network</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* <section className='lg:py-[70px] py-[50px] lg:px-[50px] px-[20px]'>
                <div className="grid lg:grid-cols-2 grid-cols-1 items-center lg:gap-[50px] gap-[40px] lg:flex-row flex-col">
                    <div data-aos="zoom-in-up" className='relative flex justify-center'>
                        <img
                            src="/assets/home/p2.png"
                            className='w-[220px] sm:w-[320px] lg:w-[420px] xl:w-[554px] object-cover'
                            alt=""
                        />
                        <img
                            src="/assets/home/img6.png"
                            className='w-[180px] sm:w-[260px] lg:w-[340px] xl:w-[472px] object-cover lg:absolute relative top-[0px] sm:top-[150px] lg:top-[180px] left-[0px] sm:left-[180px] lg:left-[220px] xl:left-[271px]'
                            alt=""
                        />
                    </div>
                    <div data-aos="fade-left" className='w-full text-center lg:text-left'>
                        <div className="flex gap-[10px] flex-col items-center lg:items-start lg:pb-[10px]">
                            <img src="/assets/home/book.svg" alt="" />
                            <p className="font-[600] font-manrope text-[16px] sm:text-[18px] lg:text-[20px] leading-[28px] sm:leading-[32px] text-primary">
                                ESSENCE OF VANS
                            </p>
                        </div>

                        <h6 className="font-[700] font-manrope text-[35px] sm:text-[36px] lg:text-[48px] leading-[40px] sm:leading-[50px] lg:leading-[67px] text-[#1F2544] pb-[20px] sm:pb-[30px] lg:pb-[40px]">
                            From Hisar's Heart to Your Heart
                        </h6>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary pb-[20px] sm:pb-[30px] lg:pb-[42px]">
                            Some things never change like the way your heart skips when you hear "Jindal" in Mumbai, Manhattan, or Melbourne. That instant recognition. That shared smile with a stranger who suddenly isn't a stranger at all. We're the only ones who truly get it the way those red-brick walls shaped our souls, the way "strength, grace, determination" flows in our veins across six continents.
                        </p>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary pb-[20px] sm:pb-[30px] lg:pb-[42px]">
                            Remember how it felt to be part of something bigger than yourself? That feeling never left. It just grew stronger.
                        </p>
                        
                        <h6 className="font-[700] font-manrope text-[18px] sm:text-[22px] lg:text-[24px] leading-[30px] sm:leading-[32px] lg:leading-[34px] text-[#1F2544] pb-[10px] sm:pb-[12px]">
                            Our Mission
                        </h6>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary lg:pb-[72px] pb-[30px]">
                            VANs exists to keep the magic of those cherished Jindal days alive! We're passionate about creating a vibrant global network where memories down the lane meet new adventures ahead. Whether you were scaling the rock garden, burning midnight oil before exams, or winning inter-house competitions, VANs helps you reconnect with those who shared your formative years while opening doors to exciting new possibilities.
                        </p>
                        <button
                            className="group flex items-center justify-center lg:justify-start gap-[20px] sm:gap-[30px] bg-primary rounded-[4px] py-[12px] sm:py-[14px] px-[18px] sm:px-[20px] font-[500] font-manrope text-[14px] sm:text-[16px] leading-[24px] sm:leading-[26px] text-[#FFFFFF] transition-all duration-300 hover:text-primary border border-primary hover:bg-transparent"
                        >
                            Read More
                            <ArrowRight
                                size={18}
                                className="transition-transform duration-300 group-hover:translate-x-1"
                            />
                        </button>
                    </div>
                </div>
            </section> */}
            {/* <section className='bg-cream lg:py-[70px] py-[50px] lg:px-[50px] px-[20px]'>
                <h6 className="text-center font-[700] font-manrope text-[35px] sm:text-[36px] pb-[20px] lg:text-[48px] leading-[40px] sm:leading-[50px] lg:leading-[67px] text-[#1F2544] ">Why VANS Matters</h6>
                <p className="text-center font-[400] font-manrope pb-[80px] text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary max-w-[1200px] w-full mx-auto">For 40 years since 1984, we've built more than a network we've created a trusted global community that spans time zones and transcends boundaries. In a world that's always shifting, we're your constant. Your safe space to belong, grow, and trust completely. Because this sisterhood runs deeper than blood it's a legacy of trust, forged in those golden Jindal years.</p>
            </section> */}
            {/* <section className='lg:py-[70px] py-[50px] lg:px-[50px] px-[20px]'>
                <div className="grid lg:grid-cols-2 grid-cols-1 items-center lg:gap-[50px] gap-[40px] lg:flex-row flex-col">
                    <div data-aos="zoom-in-up" className='relative flex justify-center'>
                        <img
                            src="/assets/home/p2.png"
                            className='w-[220px] sm:w-[320px] lg:w-[420px] xl:w-[554px] object-cover'
                            alt=""
                        />
                        <img
                            src="/assets/home/img6.png"
                            className='w-[180px] sm:w-[260px] lg:w-[340px] xl:w-[472px] object-cover lg:absolute relative top-[0px] sm:top-[150px] lg:top-[180px] left-[0px] sm:left-[180px] lg:left-[220px] xl:left-[271px]'
                            alt=""
                        />
                    </div>
                    <div data-aos="fade-left" className='w-full text-center lg:text-left'>
                        <div className="flex gap-[10px] flex-col items-center lg:items-start lg:pb-[10px]">
                            <img src="/assets/home/book.svg" alt="" />
                            <p className="font-[600] font-manrope text-[16px] sm:text-[18px] lg:text-[20px] leading-[28px] sm:leading-[32px] text-primary">
                                Why VANS?
                            </p>
                        </div>

                        <h6 className="font-[700] font-manrope text-[35px] sm:text-[36px] lg:text-[48px] leading-[40px] sm:leading-[50px] lg:leading-[67px] text-[#1F2544] pb-[20px] sm:pb-[30px] lg:pb-[40px]">
                            About VANS
                        </h6>
                        <h6 className="font-[700] font-manrope text-[18px] sm:text-[22px] lg:text-[24px] leading-[30px] sm:leading-[32px] lg:leading-[34px] text-[#1F2544] pb-[10px] sm:pb-[12px]">
                            Remember Those Red-Brick Mornings?
                        </h6>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary pb-[20px] sm:pb-[30px] lg:pb-[42px]">
                            The sound of the assembly bell... Racing down those familiar corridors... Sharing tuck & secrets in the dormitory after lights out... The thrill of house competitions... That one teacher who changed everything...
                        </p>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary pb-[20px] sm:pb-[30px] lg:pb-[42px]">
                            These weren't just school days. They were the days that made us who we are.
                        </p>

                        <h6 className="font-[700] font-manrope text-[18px] sm:text-[22px] lg:text-[24px] leading-[30px] sm:leading-[32px] lg:leading-[34px] text-[#1F2544] pb-[10px] sm:pb-[12px]">
                            Our Mission
                        </h6>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary lg:pb-[72px] pb-[30px]">
                            We exist because some friendships are too beautiful to fade, some memories too precious to forget, and some bonds too strong for time or distance to break.
                        </p>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary lg:pb-[72px] pb-[30px]">
                            VANS is here to ensure that the girl who shared her tiffin with you can still share her dreams with you. That the laughter echoing through those red-brick corridors never really stops. That every Jindalite, no matter where life takes her, always has a home to return to. We're not just preserving the past we're building bridges between who we were and who we're becoming.
                        </p>
                        <p className="font-[400] font-manrope text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary lg:pb-[72px] pb-[30px]">
                            Because the best chapters of our story are still being written, together.
                        </p>
                        <button
                            className="group flex items-center justify-center lg:justify-start gap-[20px] sm:gap-[30px] bg-primary rounded-[4px] py-[12px] sm:py-[14px] px-[18px] sm:px-[20px] font-[500] font-manrope text-[14px] sm:text-[16px] leading-[24px] sm:leading-[26px] text-[#FFFFFF] transition-all duration-300 hover:text-primary border border-primary hover:bg-transparent"
                        >
                            Read More
                            <ArrowRight
                                size={18}
                                className="transition-transform duration-300 group-hover:translate-x-1"
                            />
                        </button>
                    </div>
                </div>
            </section> */}
            {/* <section className='lg:py-[70px] py-[50px] lg:px-[50px] px-[20px] bg-cream'>
                <h6 className="text-center font-[700] font-manrope pb-[20px] text-[35px] sm:text-[36px] lg:text-[48px] leading-[40px] sm:leading-[50px] lg:leading-[67px] text-[#1F2544] ">SHE CAN DO IT, SO CAN YOU</h6>
                <p className="text-center font-[400] font-manrope pb-[80px] max-w-[1200px] w-full mx-auto text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary">From the same corridors of Hisar to corner offices worldwide, from dormitory dreams to boardroom realities – our Jindalite sisters are proof that with determination and sisterhood, anything is possible.</p>
                <div className="max-w-[1200px] w-full mx-auto overflow-hidden">
                    <SeeSlider />
                </div>
            </section> */}
            <section className='video-section hidden relative'>
                <div className='px-[20px] sm:px-[40px] absolute z-10 bottom-0 w-full'>
                    <div className='gap-[20px] flex flex-col lg:flex-row justify-center items-center lg:items-end text-center lg:text-left'>
                        <div className='max-w-[525px] w-full'>
                            <img src="/assets/home/btn.png" alt="" className='mx-auto lg:h-auto h-[60px] lg:mx-0' />
                            <p className="font-[700] font-manrope text-[20px] sm:text-[24px] lg:text-[30px] leading-[32px] sm:leading-[38px] lg:leading-[48px] text-[#FB6D48] pt-[14px] pb-[10px]">
                                Discover Excellence
                            </p>
                            <h6 className="font-[700] font-manrope text-[28px] sm:text-[36px] lg:text-[48px] leading-[40px] sm:leading-[52px] lg:leading-[67px] text-[#FFFFFF] pb-[10px] sm:pb-[28px] lg:pb-[36px]">
                                Your Global VDJS Community
                            </h6>
                            <p className="font-[400] font-manrope pb-[10px] text-[14px] leading-[21px] text-center text-[#FFFFFF]">Remember those school assembly promises about changing the world? Look around – VDJS girls are doing just that! From boardrooms to operating theaters, classrooms to courtrooms, VDJS are making waves across 45+ countries. Our network isn't just an alumni database; it's a living testament to how those morning bells, evening preps, and countless shared laughs shaped us into the women we are today.</p>
                            <p className="font-[400] font-manrope pb-[10px] text-[14px] leading-[21px] text-center text-[#FFFFFF]">When a VDJS meets another anywhere in the world, there's an instant bond – that unspoken understanding that comes from walking the same corridors and sharing the same dreams under the Hisar sky.</p>
                        </div>
                        <div className="flex gap-[15px] sm:gap-[20px] justify-center">
                            <div className='relative max-w-[385px] w-full sm:w-[160px] lg:w-auto'>
                                <img
                                    src="/assets/home/btn.png"
                                    className='absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 h-[40px] sm:h-[50px] lg:h-[60px] w-[40px] sm:w-[50px] lg:w-[60px] object-cover'
                                    alt=""
                                />
                                <img src="/assets/home/img8.png" alt="" className='w-[385px] h-[200px] object-cover' />
                            </div>
                            {/* 
                            <div className='relative w-[120px] sm:w-[160px] lg:w-auto'>
                                <img
                                    src="/assets/home/btn.png"
                                    className='absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 h-[40px] sm:h-[50px] lg:h-[60px] w-[40px] sm:w-[50px] lg:w-[60px] object-cover'
                                    alt=""
                                />
                                <img src="/assets/home/img9.png" alt="" className='w-full h-auto' />
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className='lg:py-[70px] py-[50px] lg:px-[60px] px-[20px]'>
                <div className="grid lg:grid-cols-2 grid-cols-1 items-center justify-center lg:gap-[50px] gap-[40px]">
                    <div data-aos="zoom-in-up" className='relative flex justify-center'>

                        <img src="/assets/home/p3.png" alt="" />

                    </div>
                    <div data-aos="fade-left" className='max-w-[640px] w-full'>
                        <h6 className="font-[800] lg:text-left text-center font-manrope text-[35px] sm:text-[32px] lg:text-[38px] leading-[38px] sm:leading-[48px] lg:leading-[60px] text-[#1F2544] lg:pb-[12px] pb-[10px]">
                            Why Join VANS?
                        </h6>
                        <p className="font-[400] font-manrope lg:text-left text-center text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] text-secondary pb-[30px] sm:pb-[40px] lg:pb-[0px]">
                            Because adulting is hard, but it's easier when you have sisters who remember your real name (not just your Instagram handle).
                        </p>
                        <h6 className="card-title">Benefits of being a member:</h6>
                        <div className='flex flex-col gap-[8px]'>
                            {acc.map((item, index) => (
                                <div key={index} className="border-b border-[#E9E9EC]">
                                    <div
                                        className="flex justify-between items-center transition-all duration-300 
             hover:bg-primary bg-[#E9E9EC] py-[12px] sm:py-[15px] px-[15px] 
             sm:px-[20px] cursor-pointer group"
                                        onClick={() => toggleAccordion(index)}
                                    >
                                        <h6
                                            className="font-[600] font-manrope text-[14px] sm:text-[16px] 
               leading-[22px] sm:leading-[26px] text-[#222222] 
               transition-colors duration-300 group-hover:text-white"
                                        >
                                            {item.label}
                                        </h6>
                                        <button className="transition-transform duration-300 group-hover:scale-110">
                                            {activeIndex === index ? (
                                                <img
                                                    src="/assets/home/minus.svg"
                                                    alt="-"
                                                    className="w-5 h-5 transition-colors duration-300 
                   group-hover:brightness-0 group-hover:invert"
                                                />
                                            ) : (
                                                <img
                                                    src="/assets/home/plush.svg"
                                                    alt="+"
                                                    className="w-5 h-5 transition-colors duration-300 
                   group-hover:brightness-0 group-hover:invert"
                                                />
                                            )}
                                        </button>
                                    </div>
                                    {activeIndex === index && (
                                        <div className="px-[15px] sm:px-[20px] py-[12px] sm:py-[15px] bg-[#FFFDF7] text-[#444] font-manrope text-[13px] sm:text-[14px] leading-[20px] sm:leading-[22px]">
                                            {item.text}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}

            <section id="gallery" className="gallery-section overflow-hidden pt-[50px] lg:pt-[70px] pb-[50px] lg:pb-[70px]">
                <div className="lg:px-[40px] px-[20px] text-center">
                    <h6 className="font-[700] font-playfair text-[35px] sm:text-3xl md:text-4xl lg:text-[48px] lg:leading-[67px] leading-[36px] text-[#FFFFFF] pb-[16px] sm:pb-[20px]">
                        <span className='text-[#ffc507]'>VANs</span> Gallery
                    </h6>
                    <p className="text-[#FFFFFF] pb-[20px] lg:pb-[38px] text-[18px] font-[400] max-w-[864px] w-full mx-auto leading-[28px] font-manrope">Explore the vibrant and dynamic life at VANs through our gallery. Our collection of photos and videos showcases the essence of our community gatherings, campus revisits, and alumni achievements</p>
                </div>
                <div className="overflow-hidden lg:px-0 px-[20px]">
                    <GallerySlider />
                </div>
            </section>


            {/* <section className='lg:py-[80px] py-[40px] overflow-hidden px-[20px]'>
                <div className='px-[20px] flex flex-col items-center md:pl-[60px] pb-[40px]'>
                    <h6 className="font-[600] font-playfair text-[40px] mb-[14px] text-[#08717D]"> What Are Our
                        <span className='text-[#ffc507]'> Alumni Experiences
                        </span> </h6>
                    <p className="text-[#4a4a4a] max-w-[540px] text-center w-full mx-auto text-[18px] font-[400] leading-[28px] font-manrope">Testimonials</p>
                </div>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className='flex flex-col lg:px-[30px] px-[0] lg:flex-row items-center gap-[20px] md:gap-[24px]'>
                        <div data-aos="fade-right" className='max-w-full lg:max-w-[674px] w-full flex flex-col h-full gap-[20px]'>
                            <div className='bg-[#FFFDF7] w-full rounded-[20px] p-[20px]'>
                                <h6 className="font-[800] font-manrope text-[48px] sm:text-[60px] md:text-[70px] leading-[56px] sm:leading-[68px] md:leading-[76px] tracking-[1px] md:tracking-[1.48px] text-primary">
                                    40+
                                </h6>
                                <p className="font-[400] font-manrope text-[14px] md:text-[16px] leading-[22px] md:leading-[26px] text-[#696D82]">
                                    Years of Excellence
                                </p>
                                <div className='pt-[30px]'>
                                    <p className="font-[400] font-manrope text-[14px] md:text-[16px] leading-[22px] md:leading-[26px] text-[#6C6D6E]">
                                        Students Graduated Building generations of confident, accomplished women since the school's founding. Our alumnae represent the living legacy of VDJS's educational philosophy.

                                    </p>
                                    <div className='flex justify-end'>
                                        <img src="/assets/event/icon1.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className='bg-[#FFFDF7] w-full rounded-[20px] p-[20px]'>
                                <h6 className="font-[800] font-manrope text-[48px] sm:text-[60px] md:text-[70px] leading-[56px] sm:leading-[68px] md:leading-[76px] tracking-[1px] md:tracking-[1.48px] text-primary">
                                    12+
                                </h6>
                                <p className="font-[400] font-manrope text-[14px] md:text-[16px] leading-[22px] md:leading-[26px] text-[#696D82]">
                                    Global Chapters
                                </p>
                                <div className='pt-[30px]'>
                                    <p className="font-[400] font-manrope text-[14px] md:text-[16px] leading-[22px] md:leading-[26px] text-[#6C6D6E]">
                                        Our Worldwide Campus Network With alumni chapters across continents, the VDJS network maintains strong connections through regional leadership and regular activities.
                                    </p>
                                    <div className='flex justify-end'>
                                        <img src="/assets/event/icon2.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full !max-w-[800px] test-slider bg-[#FFFDF7] rounded-[20px] md:rounded-[30px] p-[20px] pb-[80px] md:p-[30px]">
                            <TestSlider />
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section className="lg:py-[80px] py-[40px] lg:px-[60px] px-[20px] relative z-10">
                <div className='px-[20px] flex flex-col items-center md:pl-[60px] pb-[40px]'>
                    <h6 className="font-[600] font-playfair text-[40px] mb-[14px] text-[#08717D]"> Our Latest
                        <span className='text-[#ffc507]'> News
                        </span> </h6>
                    <p className="text-[#4a4a4a] max-w-[840px] text-center w-full mx-auto text-[18px] font-[400] leading-[28px] font-manrope">Stay updated with the latest happenings in the VDJS Alumni Network! From groundbreaking achievements by our alumnae to exciting reunion events and new initiative launches.</p>
                </div>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-[30px]">
                        <div data-aos="fade-right" className="bg-[#FFFDF7] rounded-[10px] p-[20px] lg:p-[40px]">
                            <img src="/assets/gallery/img5.png" className="w-full h-auto rounded-[8px]" alt="" />
                            <h6 className="pt-[20px] lg:pt-[40px] font-[700] font-manrope pb-[20px] lg:pb-[42px] text-[22px] lg:text-[30px] leading-[32px] lg:leading-[48px] text-[#1F2544]">
                                The Evolution of Technology: From Gutenberg to the Internet
                            </h6>
                            <button className="flex gap-[12px] items-center font-[400] font-manrope text-[14px] lg:text-[16px] leading-[24px] lg:leading-[26px] text-primary">
                                Read More <img src="/assets/event/arrow.svg" alt="" />
                            </button>
                        </div>
                        <div data-aos="fade-left" className="bg-[#FFFDF7] rounded-[10px] p-[20px] lg:p-[40px] grid grid-cols-1 lg:gap-[68px] gap-[20px]">
                            <div className="flex flex-col sm:flex-row gap-[20px] items-start sm:items-center">
                                <img src="/assets/gallery/img8.png" className="w-full sm:max-w-[198px] rounded-[8px]" alt="" />
                                <div>
                                    <h6 className="font-[600] font-manrope text-[18px] lg:text-[20px] leading-[28px] lg:leading-[30px] text-[#1F2544] pb-[12px] lg:pb-[24px]">
                                        The Future of Education: Exploring Virtual Learning Platforms
                                    </h6>
                                    <button className="flex gap-[12px] items-center font-[400] font-manrope text-[14px] lg:text-[16px] leading-[24px] lg:leading-[26px] text-primary">
                                        Read More <img src="/assets/event/arrow.svg" alt="" />
                                    </button>
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-[20px] items-start sm:items-center">
                                <img src="/assets/gallery/img7.png" className="w-full sm:max-w-[198px] rounded-[8px]" alt="" />
                                <div>
                                    <h6 className="font-[600] font-manrope text-[18px] lg:text-[20px] leading-[28px] lg:leading-[30px] text-[#1F2544] pb-[12px] lg:pb-[24px]">
                                        Cultural Exchange Spotlight: Student Stories Abroad
                                    </h6>
                                    <button className="flex gap-[12px] items-center font-[400] font-manrope text-[14px] lg:text-[16px] leading-[24px] lg:leading-[26px] text-primary">
                                        Read More <img src="/assets/event/arrow.svg" alt="" />
                                    </button>
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-[20px] items-start sm:items-center">
                                <img src="/assets/gallery/img6.png" className="w-full sm:max-w-[198px] rounded-[8px]" alt="" />
                                <div>
                                    <h6 className="font-[600] font-manrope text-[18px] lg:text-[20px] leading-[28px] lg:leading-[30px] text-[#1F2544] pb-[12px] lg:pb-[24px]">
                                        The Power of Mindfulness: Cultivating Inner Peace
                                    </h6>
                                    <button className="flex gap-[12px] items-center font-[400] font-manrope text-[14px] lg:text-[16px] leading-[24px] lg:leading-[26px] text-primary">
                                        Read More <img src="/assets/event/arrow.svg" alt="" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section> */}
            <section className='lg:pt-[80px] pb-[80px] relative pt-[50px] lg:px-[60px] px-[20px] bg-cream'>
                <div className="max-w-[1280px] w-full mx-auto">
                    <div className='flex flex-col items-center pb-[64px]'>
                        <h6 className="font-[600] font-playfair text-[40px] mb-[24px] text-[#08717D]">Frequently Asked
                            <span className='text-[#ffc507]'> Questions
                            </span></h6>
                        <p className="text-[#4a4a4a] text-center text-[18px] max-w-[768px] w-full mx-auto font-[400] leading-[28px] font-manrope">Everything you need to know about joining our sisterhood</p>
                    </div>
                    <div className="grid lg:gap-[20px] gap-[14px]">
                        {faqs.map((item, index) => (
                            <div key={index} className=" bg-[#08717D]/50 rounded-[8px]  self-start">
                                <div
                                    className={`flex justify-between items-center ${activeIndex2 === index ? "rounded-t-[8px]" : "rounded-[8px]"} transition-all duration-300 hover:bg-primary bg-[#E9E9EC] py-[12px] sm:py-[15px] px-[15px] sm:px-[20px] cursor-pointer group`}
                                    onClick={() => toggleAccordion2(index)}
                                >
                                    <h6
                                        className="font-[600] font-manrope text-[14px] sm:text-[16px] 
          leading-[22px] sm:leading-[26px] text-[#222222] 
          transition-colors duration-300 group-hover:text-white"
                                    >
                                        {item.label}
                                    </h6>
                                    <button className="transition-transform duration-300 group-hover:scale-110">
                                        <svg className={`w-5 h-5 group-hover:text-[#FFFFFF] ${activeIndex2 === index ? "rotate-[180deg]" : "rotate-[0deg]"} transition-all duration-300`} id="faq-icon-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-component-id="9-0-1-4-0-0-1" data-component-path="/pages/landing_page.html" data-component-name="svg" data-component-file="landing_page.html" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-5%20h-5%20text-text-secondary%20transform%20transition-transform%22%2C%22id%22%3A%22faq-icon-5%22%7D">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </button>
                                </div>

                                <div
                                    className={`overflow-hidden rounded-b-[8px] transition-[max-height] duration-500 ease-in-out ${activeIndex2 === index ? "max-h-[500px]" : "max-h-0"
                                        }`}
                                >
                                    <div className="px-[15px] sm:px-[20px] py-[12px] sm:py-[15px]  bg-[#08717D]/30  text-[#FFFFFF] font-manrope text-[13px] sm:text-[14px] leading-[20px] sm:leading-[22px]">
                                        {item.text}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* <div id="contact" className="update-section py-[40px] lg:py-[92px] absolute w-full lg:bottom-[-120px] bottom-[-100px] z-20 mx-auto left-[50%] translate-x-[-50%] lg:px-[110px] px-[20px]">
                    <div className="flex justify-between items-center lg:flex-row flex-col gap-[20px]">
                        <div className="text-center lg:text-left">
                            <h6 className="font-[700] font-manrope text-[28px] lg:text-[38px] leading-[40px] lg:leading-[60px] text-[#FFFFFF] pb-[10px]">
                                Get updates
                            </h6>
                            <p className="font-[400] font-manrope text-[14px] lg:text-[16px] leading-[22px] lg:leading-[26px] text-[#E9E9EC]">
                                Stay Informed with the Latest News and Announcements
                            </p>
                        </div>
                        <div className="max-w-[553px] w-full flex flex-row justify-between items-center border-[1px] rounded-full border-[#FFFFFF] overflow-hidden">
                            <input
                                type="text"
                                className="py-[6px] sm:py-[18px] pl-[20px] border-none bg-transparent focus:outline-none focus:ring-0 font-[400] font-manrope text-[14px] text-[#FFFFFF]"
                                placeholder="hello@yourdomain.com"
                            />
                            <button className="bg-[#C0E6EB] rounded-full py-[14px] sm:py-[17px] px-[20px] font-[400] font-manrope lg:text-[14px] text-[11px] leading-[11px] lg:leading-[26px] text-center text-[#08717D]">
                                Subscribe now
                            </button>
                        </div>
                    </div>
                </div> */}
            </section>
            {openModal && (
                <RegisterModal setOpenModal={setOpenModal} />
            )}
        </>
    )
}

export default Home